import React from 'react';
import '../css/header.css';

const Language = ({ onChangelanguageEn,onChangelanguageKo }) => {
	return (
		<div className='language_modal_box'>
			<button onClick={onChangelanguageEn}>EN</button>
			<button onClick={onChangelanguageKo}>KO</button>
		</div>
	);
};

export default Language;
